export enum BPMethod {
  NIBP = 'NIBP',

  IBP = 'IBP',
}
